import { render, staticRenderFns } from "./SkeletonScreen.vue?vue&type=template&id=b284d444&scoped=true"
import script from "./SkeletonScreen.vue?vue&type=script&lang=js"
export * from "./SkeletonScreen.vue?vue&type=script&lang=js"
import style0 from "./SkeletonScreen.vue?vue&type=style&index=0&id=b284d444&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b284d444",
  null
  
)

export default component.exports